import { ImageLoaderProps } from 'next/image';

const urlMappings: { [key: string]: string } = {
    'images.beta.cademy.co.uk': 'https://cademy-images-beta.b-cdn.net',
    'images.cademy.co.uk': 'https://cademy-images.b-cdn.net',
    'assets.cademy.co.uk': 'https://cademy-assets.b-cdn.net',
    'images.beta.cademy.io': 'https://cademy-images-beta-io.b-cdn.net',
    'images.cademy.io': 'https://cademy-images-io.b-cdn.net',
    'assets.cademy.io': 'https://cademy-assets-io.b-cdn.net',
    'images.beta.cademy.be': 'https://cademy-images-beta-be.b-cdn.net',
    'images.cademy.be': 'https://cademy-images-be.b-cdn.net',
    'assets.cademy.be': 'https://cademy-assets-be.b-cdn.net',
    'forum-attachments.beta.cademy.io': 'https://forum-attachments.beta.cademy.io',
    'forum-attachments.cademy.io': 'https://forum-attachments.cademy.io',
};

export default function bunnyNetLoader({ src, width, quality }: ImageLoaderProps) {
    // Handle Strapi uploads - convert to absolute URL pointing to local Strapi
    if (src.startsWith('/uploads/')) {
        let strapiDomain =
            process.env.NEXT_PUBLIC_STRAPI_CMS_API_DOMAIN?.replace('/api', '') ||
            'http://localhost:1337';

        if (!strapiDomain.startsWith('http://') && !strapiDomain.startsWith('https://')) {
            strapiDomain = `https://${strapiDomain}`;
        }

        return `${strapiDomain}${src}`;
    }

    // If src is a relative path (starts with /), return it as-is
    // This handles cases like /_next/static/media/... or /images/...
    if (src.startsWith('/')) {
        return src;
    }

    try {
        const url = new URL(src);
        const host = url.hostname;

        const mapping = urlMappings[host];
        if (mapping) {
            const qualityParam = quality ? `&quality=${quality}` : '';
            return `${mapping}${url.pathname}?width=${width}${qualityParam}`;
        }
    } catch (e) {
        console.error(e);
    }

    return src;
}
